import { CLIENT_ROLE_ID } from "@/app/constants/roleConstants";
import { resolveAuthJwtExpiry } from "@/app/lib/auth/jwt-expiry";

/** Default client login JWT lifetime (device session cap). */
export const DEFAULT_CLIENT_JWT_EXPIRY = "48h";

export function isClientRoleId(roleId: number | null | undefined): boolean {
  return roleId === CLIENT_ROLE_ID;
}

/**
 * Resolve JWT `exp` for client accounts. Always capped at 48h (env override optional).
 * `rememberMe` is ignored for clients.
 */
export function resolveClientJwtExpiry(): string {
  const fromEnv = process.env.JWT_CLIENT_ACCESS_EXPIRY?.trim();
  return fromEnv || DEFAULT_CLIENT_JWT_EXPIRY;
}

/** Clients always use localStorage so the full 48h applies on the device. */
export function shouldPersistClientAuthInLocalStorage(
  roleId: number | null | undefined
): boolean {
  return isClientRoleId(roleId);
}

/**
 * Role-aware JWT expiry: clients always 48h; staff uses remember-me policy.
 */
export function resolveAuthJwtExpiryForRole(
  roleId: number | null | undefined,
  rememberMe: boolean
): string {
  if (isClientRoleId(roleId)) {
    return resolveClientJwtExpiry();
  }
  return resolveAuthJwtExpiry(rememberMe);
}

/**
 * Whether the JWT should include the remember-me (`rm`) claim.
 * Clients never get `rm` since sessions are capped at 48h.
 */
export function shouldSetRememberMeClaim(
  roleId: number | null | undefined,
  rememberMe: boolean
): boolean {
  if (isClientRoleId(roleId)) {
    return false;
  }
  return rememberMe;
}
